// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8f673267","246":"fe2edd87","312":"5a3fa57c","703":"231c6d61","729":"a36f4117","787":"9961f5fd"}[chunkId] + ".chunk.js";
};